var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTurkeyFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  height: 32,
  width: 32
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e30917",
  d: "M32 24a3.556 3.556 0 0 1-3.556 3.556H3.556A3.556 3.556 0 0 1 0 24V8a3.556 3.556 0 0 1 3.556-3.556h24.888A3.556 3.556 0 0 1 32 8v16z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#eee",
  d: "M14.222 21.333a5.333 5.333 0 1 1 0-10.667c1.165 0 2.24.378 3.118 1.012a6.517 6.517 0 0 0-4.896-2.214 6.536 6.536 0 0 0 0 13.073c1.952 0 3.698-.86 4.896-2.215a5.3 5.3 0 0 1-3.118 1.011zm3.478-5.129 2.17.5.195 2.216 1.145-1.908 2.169.5-1.462-1.68 1.144-1.908-2.047.872-1.461-1.68.195 2.217z"
})));
export default SvgTurkeyFlag;